import { ForwardedRef, forwardRef } from 'react';

import { cx } from '@libs/classnames';
import { BurgerIcon } from '@ui/icons/BurgerIcon';

import styles from './DragHandle.module.css';

type Props = {
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  tabIndex?: number;
};
export const DragHandle = forwardRef(function DragHandleInternal(
  { className, disabled, onClick, ...restProps }: Props,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <div
      ref={ref}
      className={cx(styles.dragHandle, { [styles.disabled]: disabled }, className)}
      {...restProps}
      onClick={onClick}
    >
      <BurgerIcon />
    </div>
  );
});
